import React from 'react'
import "./miTitulo.css"

const Titulo = ({greeting}) => {
    return (
        <h2 className="title-2">{greeting}</h2>
    )
}

export default Titulo